import {createAction, props} from '@ngrx/store';
import {IStaticPages} from '../model/static-pages.model';

export enum StaticPagesActions {
  TermsAndConditions = '[Auth Effects] TermsAndConditions',
  TermsAndConditionsSuccess = '[TermsAndConditions Effects] TermsAndConditions Success',
  TermsAndConditionsFailure = '[TermsAndConditions Effects] TermsAndConditions Failure',
  TermsAndConditionsError = '[TermsAndConditions Effects] TermsAndConditions Error',

  LegalNotice = '[LegalNotice Component] LegalNotice',
  LegalNoticeSuccess = '[LegalNotice Effects] LegalNotice Success',
  LegalNoticeFailure = '[LegalNotice Effects] LegalNotice Failure',
  LegalNoticeError = '[LegalNotice Effects] LegalNotice Error',

  PrivacyPolicy = '[PrivacyPolicy Component] PrivacyPolicy',
  PrivacyPolicySuccess = '[PrivacyPolicy Effects] PrivacyPolicy Success',
  PrivacyPolicyFailure = '[PrivacyPolicy Effects] PrivacyPolicy Failure',
  PrivacyPolicyError = '[PrivacyPolicy Effects] PrivacyPolicy Error',

  CookiePolicy = '[CookiePolicy Component] CookiePolicy',
  CookiePolicySuccess = '[CookiePolicy Effects] CookiePolicy Success',
  CookiePolicyFailure = '[CookiePolicy Effects] CookiePolicy Failure',
  CookiePolicyError = '[CookiePolicy Effects] CookiePolicy Error',

  Contact = '[Contact Component] Contact',
  ContactSuccess = '[Contact Effects] Contact Success',
  ContactFailure = '[Contact Effects] Contact Failure',
  ContactError = '[Contact Effects] Contact Error',

  WelcomePage = '[Auth Effects] WelcomePage',
  WelcomePageSuccess = '[WelcomePage Effects] WelcomePage Success',
  WelcomePageFailure = '[WelcomePage Effects] WelcomePage Failure',
  WelcomePageError = '[WelcomePage Effects] WelcomePage Error',

  HowtoOrderPage = '[Auth Effects] HowtoOrderPage',
  HowtoOrderPageSuccess = '[HowtoOrderPage Effects] HowtoOrderPage Success',
  HowtoOrderPageFailure = '[HowtoOrderPage Effects] HowtoOrderPage Failure',
  HowtoOrderPageError = '[HowtoOrderPage Effects] HowtoOrderPage Error',
}
export const termsAndConditionsAction = createAction(
  StaticPagesActions.TermsAndConditions,
  props<{request: {key: number; languageId: number}}>()
);
export const termsAndConditionsEffectSuccess = createAction(
  StaticPagesActions.TermsAndConditionsSuccess,
  props<{response: IStaticPages}>()
);
export const termsAndConditionsEffectFailure = createAction(
  StaticPagesActions.TermsAndConditionsFailure,
  props<{reason: string}>()
);
export const termsAndConditionsEffectError = createAction(
  StaticPagesActions.TermsAndConditionsError,
  props<{error: string}>()
);

export const legalNoticeAction = createAction(
  StaticPagesActions.LegalNotice,
  props<{request: {key: number; languageId: number}}>()
);
export const legalNoticeEffectSuccess = createAction(
  StaticPagesActions.LegalNoticeSuccess,
  props<{response: IStaticPages}>()
);
export const legalNoticeEffectFailure = createAction(StaticPagesActions.LegalNoticeFailure, props<{reason: string}>());
export const legalNoticeEffectError = createAction(StaticPagesActions.LegalNoticeError, props<{error: string}>());

export const privacyPolicyAction = createAction(
  StaticPagesActions.PrivacyPolicy,
  props<{request: {key: number; languageId: number}}>()
);
export const privacyPolicyEffectSuccess = createAction(
  StaticPagesActions.PrivacyPolicySuccess,
  props<{response: IStaticPages}>()
);
export const privacyPolicyEffectFailure = createAction(
  StaticPagesActions.PrivacyPolicyFailure,
  props<{reason: string}>()
);
export const privacyPolicyEffectError = createAction(StaticPagesActions.PrivacyPolicyError, props<{error: string}>());

export const cookiePolicyAction = createAction(
  StaticPagesActions.CookiePolicy,
  props<{request: {key: number; languageId: number}}>()
);
export const cookiePolicyEffectSuccess = createAction(
  StaticPagesActions.CookiePolicySuccess,
  props<{response: IStaticPages}>()
);
export const cookiePolicyEffectFailure = createAction(
  StaticPagesActions.CookiePolicyFailure,
  props<{reason: string}>()
);
export const cookiePolicyEffectError = createAction(StaticPagesActions.CookiePolicyError, props<{error: string}>());

export const contactAction = createAction(
  StaticPagesActions.Contact,
  props<{request: {key: number; languageId: number}}>()
);
export const contactEffectSuccess = createAction(StaticPagesActions.ContactSuccess, props<{response: IStaticPages}>());
export const contactEffectFailure = createAction(StaticPagesActions.ContactFailure, props<{reason: string}>());
export const contactEffectError = createAction(StaticPagesActions.ContactError, props<{error: string}>());

export const welcomePageAction = createAction(
  StaticPagesActions.WelcomePage,
  props<{request: {key: number; languageId: number}}>()
);
export const welcomePageEffectSuccess = createAction(
  StaticPagesActions.WelcomePageSuccess,
  props<{response: IStaticPages}>()
);
export const welcomePageEffectFailure = createAction(StaticPagesActions.WelcomePageFailure, props<{reason: string}>());
export const welcomePageEffectError = createAction(StaticPagesActions.WelcomePageError, props<{error: string}>());

export const howtoOrderPageAction = createAction(
  StaticPagesActions.HowtoOrderPage,
  props<{request: {key: number; languageId: number}}>()
);
export const howtoOrderPageEffectSuccess = createAction(
  StaticPagesActions.HowtoOrderPageSuccess,
  props<{response: IStaticPages}>()
);
export const howtoOrderPageEffectFailure = createAction(
  StaticPagesActions.HowtoOrderPageFailure,
  props<{reason: string}>()
);
export const howtoOrderPageEffectError = createAction(StaticPagesActions.HowtoOrderPageError, props<{error: string}>());
